/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OfferRejectionReason } from './OfferRejectionReason';
import {
    OfferRejectionReasonFromJSON,
    OfferRejectionReasonFromJSONTyped,
    OfferRejectionReasonToJSON,
} from './OfferRejectionReason';
import type { OfferTerminationReason } from './OfferTerminationReason';
import {
    OfferTerminationReasonFromJSON,
    OfferTerminationReasonFromJSONTyped,
    OfferTerminationReasonToJSON,
} from './OfferTerminationReason';

/**
 * 
 * @export
 * @interface StatusReason1
 */
export interface StatusReason1 {
}

/**
 * Check if a given object implements the StatusReason1 interface.
 */
export function instanceOfStatusReason1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StatusReason1FromJSON(json: any): StatusReason1 {
    return StatusReason1FromJSONTyped(json, false);
}

export function StatusReason1FromJSONTyped(json: any, ignoreDiscriminator: boolean): StatusReason1 {
    return json;
}

export function StatusReason1ToJSON(value?: StatusReason1 | null): any {
    return value;
}

